export default "__VITE_ASSET__ft2IQLHC__"